/* eslint-disable no-magic-numbers */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable max-lines */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';

import ProductListPage from 'Component/ProductListPage';
import SourceProductList from 'SourceComponent/ProductList/ProductList.component';
import { HistoryType } from 'Type/Router.type';

import './ProductList.extended.style';

/**
 * Category sort
 * @class CategorySort
 * @namespace Scandipwa/Component/ProductList/Component */
export class ProductListComponent extends SourceProductList {
    static propTypes = {
        ...super.propTypes,
        history: HistoryType.isRequired,
        isPageLoading: PropTypes.bool.isRequired
    };

    /**
     * Default state
     *
     * @type {{infiniteLoader: boolean}}
     */
    state = {
        // On search page we will have infinite scroll by default
        infiniteLoader: /search/.test(window.location.pathname),
        pagesLoaded: 1,
        triggerPageThreeLoad: false
    };

    showNextInfiniteScrollPage = this.showNextInfiniteScrollPage.bind(this);

    shouldComponentUpdate(nextProps, nextState) {
        const { pagesLoaded: pagesFromState } = nextState;
        const { pagesLoaded: prevPagesFromState } = this.state;
        const {
            pages = {},
            pagesNumberToShow: nextPagesNumberToShow,
            sort,
            selectedFilters
        } = nextProps;
        const {
            pages: prevPages = {},
            pagesNumberToShow,
            sort: prevSort,
            selectedFilters: prevSelectedFilters
        } = this.props;

        if (JSON.stringify(sort) !== JSON.stringify(prevSort)
            || JSON.stringify(selectedFilters) !== JSON.stringify(prevSelectedFilters)) {
            this.setState({ infiniteLoader: false });
        }

        const pagesLoaded = Object.values(pages).length;
        const prevPagesLoaded = Object.values(prevPages).length;
        const { isLoading, isPageLoading } = nextProps;
        const { isLoading: prevIsLoading, isPageLoading: prevIsPageLoading } = this.props;

        return isLoading !== prevIsLoading
            || isPageLoading !== prevIsPageLoading
            || pagesLoaded !== prevPagesLoaded
            || pagesFromState !== prevPagesFromState
            || nextPagesNumberToShow !== pagesNumberToShow;
    }

    /**
     * On component did update
     *
     * @param prevProps
     */
    componentDidUpdate(prevProps) {
        const {
            pages = {},
            requestPage,
            pagesNumberToShow,
            updatePagesNumberToShow
        } = this.props;
        const { pages: prevPages = {} } = prevProps;
        const { triggerPageThreeLoad, infiniteLoader } = this.state;
        const pagesLoaded = Math.max(...Object.keys(pages));
        const prevPagesLoaded = Math.max(...Object.keys(prevPages));

        if (pagesLoaded !== prevPagesLoaded) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ pagesLoaded });

            if (pagesLoaded === 2 && triggerPageThreeLoad) {
                updatePagesNumberToShow(infiniteLoader ? pagesNumberToShow + 1 : pagesNumberToShow);
                this.setState({
                    triggerPageThreeLoad: false
                }, () => requestPage(3, true));
            }
        }

        this.observePageChange();
    }

    showNextInfiniteScrollPage(newVal) {
        const { infiniteLoader } = this.state;
        const {
            requestPage,
            totalPages,
            pagesNumberToShow,
            updatePagesNumberToShow
        } = this.props;

        // Page 1 is automatically loaded, page 2 is loaded by clicking "show more/all" buttons, so start from page 3
        if (!infiniteLoader || typeof (newVal) !== 'number' || newVal < 3) {
            return;
        }

        if (newVal > pagesNumberToShow) {
            updatePagesNumberToShow(newVal);

            if (newVal <= totalPages) {
                requestPage(newVal, true);
            }
        }
    }

    /**
     * Renders load more button
     *
     * @returns {JSX.Element|null}
     */
    renderLoadMoreButton() {
        const {
            loadPage,
            pageSize,
            totalItems,
            currentPage,
            pagesNumberToShow,
            updatePagesNumberToShow
        } = this.props;
        const { pagesLoaded } = this.state;

        const productsLeftToLoad = totalItems - pageSize * currentPage;
        const nextPageSize = (productsLeftToLoad < pageSize) ? productsLeftToLoad : pageSize;
        const url = new URL(window.location.href);
        url.searchParams.set('page', currentPage + 1);// set correct url for anchor tag href attribute

        return (
            <a
              block="ProductList"
              elem="LoadProductsButton"
              mods={ { type: 'loadMore' } }
              href={ `${ url}` }
              onClick={ (event) => {
                  event.preventDefault();
                  loadPage();
                  updatePagesNumberToShow(pagesNumberToShow + 1);

                  // if user clicks the button before request for page 2 is resolved, prepare page 3 as well.
                  if (pagesLoaded === 1) {
                      this.setState({ triggerPageThreeLoad: true });
                  }
              } }
            >
                { __('%s More Items', nextPageSize) }
            </a>
        );
    }

    /**
     * Renders load all button
     *
     * @returns {JSX.Element}
     */
    renderLoadAllButton() {
        const { pagesLoaded } = this.state;
        const {
            pagesNumberToShow,
            updatePagesNumberToShow,
            loadPage,
            pages = {}
        } = this.props;

        return (
            <button
              block="ProductList"
              elem="LoadProductsButton"
              mods={ { type: 'loadAll' } }
              mix={ { block: 'Button', elem: 'AddToCart' } }
              onClick={ () => {
                  updatePagesNumberToShow(pagesNumberToShow + 1);
                  this.setState({ infiniteLoader: true });

                  // if user clicks the button before request for page 2 is resolved, prepare page 3 as well.
                  if (pagesLoaded === 1) {
                      this.setState({ triggerPageThreeLoad: true });
                  }

                  if (Math.max(...Object.keys(pages)) > 2) {
                      loadPage();
                  }
              } }
            >
                { __('Show All') }
            </button>
        );
    }

    /**
     * Renders pagination buttons
     *
     * @returns {JSX.Element}
     */
    renderPaginationButtons() {
        const {
            totalPages,
            isLoading,
            areComponentsLoading,
            isInfoLoading,
            pagesNumberToShow
        } = this.props;
        const { infiniteLoader, pagesLoaded } = this.state;

        if (
            pagesNumberToShow === totalPages
            || (isLoading && pagesNumberToShow !== pagesLoaded)
            || (areComponentsLoading && isInfoLoading)
            || infiniteLoader
        ) {
            return null;
        }

        return (
            <div
              block="ProductList"
              elem="PaginationButtons"
              mods={ { isVisible: !infiniteLoader } }
            >
                { this.renderLoadMoreButton() }
                { this.renderLoadAllButton() }
            </div>
        );
    }

    renderProductPage([key, items = []]) {
        const { selectedFilters } = this.props;

        const pageNumber = +key;

        return this.renderPage({
            selectedFilters,
            pageNumber,
            items,
            key,
            wrapperRef: (node) => {
                this.nodes[pageNumber] = node;
            }
        });
    }

    /**
     * Renders pages
     *
     * @returns {unknown[]|*}
     */
    renderPages() {
        const {
            pages,
            isVisible,
            isLoading,
            isPageLoading,
            isInfiniteLoaderEnabled,
            totalPages
        } = this.props;
        const { infiniteLoader, pagesLoaded } = this.state;

        if (isLoading) {
            return this.renderPage();
        }

        const pageRenders = Object.entries(pages).map(this.renderProductPage.bind(this));

        if (
            isVisible
            && isInfiniteLoaderEnabled
            && (infiniteLoader || isPageLoading)
            && pagesLoaded !== totalPages
        ) { // add placeholders to the end of pages if needed
            const key = Math.max(Object.keys(pages)) + 1; // the key should match next page key
            pageRenders.push(this.renderPage({ key }));
        }

        return pageRenders;
    }

    /**
     * Renders page
     *
     * @param props
     * @returns {JSX.Element}
     */
    renderPage(props = {}) {
        const {
            isInfiniteLoaderEnabled,
            isLoading,
            isVisible,
            currentPage,
            mix,
            areMenuFiltersLoading,
            history,
            pagesNumberToShow
        } = this.props;
        const { infiniteLoader } = this.state;

        const newProps = this._processProps(props);
        const { key } = newProps;

        if (+key > pagesNumberToShow) {
            return null;
        }

        return (
            <ProductListPage
              key={ currentPage }
              isInfiniteLoaderEnabled={ isInfiniteLoaderEnabled && infiniteLoader }
              updatePages={ this.showNextInfiniteScrollPage }
              isLoading={ isLoading || areMenuFiltersLoading }
              isVisible={ isVisible }
              mix={ mix }
              history={ history }
              { ...newProps }
            />
        );
    }

    renderLoadButton() {
        const {
            isShowLoading,
            isInfiniteLoaderEnabled,
            loadPrevPage
        } = this.props;

        if (!isShowLoading || !isInfiniteLoaderEnabled) {
            return null;
        }

        return (
            <div
              block="ProductList"
              elem="LoadButton"
              mix={ { block: 'Button', elem: 'Primary' } }
              role="button"
              tabIndex="0"
              onKeyUp={ loadPrevPage }
              onClick={ loadPrevPage }
            >
                { __('Load previous') }
            </div>
        );
    }

    render() {
        const {
            totalPages,
            isLoading,
            mix
        } = this.props;

        if (!isLoading && totalPages === 0) {
            return this.renderNoProducts();
        }

        return (
            <div
              block="ProductList"
              mods={ { isLoading } }
              mix={ mix }
            >
                { this.renderTitle() }
                { this.renderLoadButton() }
                { this.renderPages() }
                { this.renderPaginationButtons() }
            </div>
        );
    }
}

export default ProductListComponent;
